export class User {
	constructor(
		public username: string, 
		public password: string, 
			// public email: string, 
		// public gender: string,	
		// public phone: string,
		){
		
	  }
}
